import React from 'react'

import { StyledInnerLoader } from './style'

const InnerLoader = ({ size = 16, color = '#51526C', stroke = 4 }) => {
  return <StyledInnerLoader size={size} color={color} stroke={stroke} />
}

export default InnerLoader
